import {http, param} from '../../utils/http'
import conf from '../../config'
import fileDownload from 'js-file-download'
import { get } from 'lodash'
export const API_ROOT = `${conf.API_URL}`

const purchaseHistoryService = {
    uploadPOImportFile(formData) {
        return http.post(`${API_ROOT}/provider/purchase-orders/upload-po-import`, formData).then(resp => {
            return resp
        })
    },
    getPurchaseHistory(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'filterModel', val: payload.filterModel ?  encodeURIComponent(JSON.stringify(payload.filterModel))  : null },
            { query: 'globalSearchText', val: payload.search ? payload.search.trim() : '' },
        ]
        return http.get(`${API_ROOT}/provider/purchase-orders${param(arr)}`).then(resp => {
            return resp
        })
    },
    downloadPOImportFile(fileId) {
        return http.get(`${API_ROOT}/provider/purchase-orders/po-import-files/${fileId}`).then(resp => {
            return resp
        })
    },
    downloadPurchaseHistoryXLSX(payload) {
        var arr = [
            { query: 'pageNumber', val: payload.pageNumber },
            { query: 'pageSize', val: payload.pageSize },
            { query: 'sortField', val: payload.sortField },
            { query: 'sortDirection', val: payload.sortDirection },
            { query: 'email', val: payload.email ? encodeURIComponent(payload.email) : null },
            { query: 'filterModel', val: payload.filterModel ? encodeURIComponent(JSON.stringify(payload.filterModel)) : null },
            { query: 'globalSearchText', val: payload.globalSearchText ? payload.globalSearchText.trim() : '' },
        ]
        return http.get(`${API_ROOT}/provider/purchase-orders/downloadAgGridPurchaseOrdersXLSX${param(arr)}`).then(resp => {
            return resp
        })
    }
}

export default purchaseHistoryService